<template>
  <div>
    <div
      class="ts-flex ts-items-center ts-justify-between ts-space-x-6 ts-mb-4 ts-py-4 ts-rounded-lg ts-shadow-lg"
    >
      <div class="ts-flex ts-items-center ts-space-x-6">
        <div class="ts-w-32">
          <h1
            class="ts-text-xl ts-capitalize ts-whitespace-no-wrap ts-font-marck-script ts-ml-4"
          >{{ $t('gameBetting.pickupNumber') }}</h1>
        </div>
        <div class="ts-flex ts-space-x-6">
          <input
            v-for="(p, index) in model.picked_number"
            :key="index"
            v-model="p.value"
            type="text"
            class="ts-outline-none ts-font-semibold ts-font-robot ts-h-16 ts-w-16 ts-py-5 ts ts-rounded-full ts-text-2xl ts-text-center ts-text-orange-600"
            :class="
          errors.has('picked_number.' + index + '.value')
            ? 'ts-border-2 ts-border-red-600'
            : ''
        "
            :style="{
          'background-repeat': 'no-repeat',
          'background-size': 'cover',
          'background-image': 'url(' + require('@/assets/ball.png') + ')'
        }"
            @input="pickJackpot"
          />
        </div>
      </div>
      <div class="ts-pr-3">
        <slot name="add-cart"></slot>
      </div>
    </div>
    <template v-if="gameSelected">
      <div
        class="ts-flex ts-items-center ts-space-x-6 ts-mt-2"
        v-for="(game, index) in channel_list"
        :key="index"
      >
        <template v-if="index > 0">
          <div
            class="ts-w-32 ts-font-semibold ts-font-pacifico ts-tracking-widest ts-text-base ts-whitespace-no-wrap ts-flex"
            :class="
              model.game_type_id == 1
                ? 'ts-ml-40 ts-border ts-border-gray-300 ts-px-4 ts-py-2 ts-rounded-md ts-pt-0'
                : ''
            "
          >
            <div class="checkbox checkbox-css">
              <input type="checkbox" @change="pickGame(game)" :checked="isChecked" />
              <label @click="event => event.target.previousSibling.click()">
                {{
                game.game_lot_name
                }}
              </label>
            </div>
            <!-- <ts-checkbox @change="pickGame(game)" :checked="rebuild">
              {{
              game.game_lot_name
              }}
            </ts-checkbox>-->
            <input
              type="number"
              v-model.number="game.multiplier"
              class="ts-ml-8 ts-border ts-border-gray-200 ts-w-12 ts-text-center ts-rounded-md ts-outline-none"
              v-if="model.game_type_id == 2"
            />
          </div>
          <template v-if="model.game_type_id == 2">
            <input
              v-for="(d, index) in game.digit_taken"
              :key="index"
              type="text"
              class="ts-outline-none ts-font-semibold ts-font-robot ts-h-16 ts-w-16 ts-py-5 ts-px-4 ts-rounded-full ts-text-2xl ts-text-center ts-text-red-600"
              :class="
                d == 0
                  ? 'ts-bg-gray-100 ts-opacity-25 ts-text-red-700'
                  : 'ts-bg-gray-300'
              "
              disabled
              :value="d == 1 ? model.picked_number[index].value : 'X'"
              :style="{
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'background-image': 'url(' + require('@/assets/ball.png') + ')'
              }"
            />
          </template>
        </template>
        <div v-if="index > 0">
          <span class="ts-px-2 ts-bg-gray-400 ts-rounded-lg">
            {{
            game.betting_amount
            }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'pickupNumber',
  props: ['gameSet', 'value', 'validate', 'rebuild'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      isChecked: false,
      channel_list: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    gameSelected() {
      return !_.isEmpty(this.gameSet)
    },
    numRow() {
      if (!_.isEmpty(this.gameSet)) {
        return this.gameSet.game_setting.game_lots
      }
      return []
    },
    isSixFortyNine() {
      if (!_.isEmpty(this.gameSet)) {
        return this.gameSet.game_setting.game_type_id == 1
      }
      return false
    }
  },
  methods: {
    createDetail() {
      this.model.picked_number = []
      let stop = this.model.game_type_id == 2 ? 4 : 5

      for (var i = 0; i <= stop; i++) {
        this.model.picked_number.push({
          value: ''
        })
      }

      if (!this.numRow.length > 0) return
      this.channel_list = this.numRow.map(el => ({
        game_lot_name: el.game_lot_name,
        game_lot_id: el.game_lot_id,
        betting_amount: el.unit_price,
        digit_taken: el.digit_taken_array,
        multiplier: 1
      }))
    },
    pickJackpot() {
      const number = _.some(this.model.picked_number, { value: '' })
      this.model.betting_detail = []
      if (!number) {
        if (this.isSixFortyNine) {
          this.channel_list.forEach(element => {
            this.model.betting_detail.push(element)
          })
        } else {
          this.model.betting_detail.push(this.channel_list[0])
        }
      }
    },
    pickGame(game) {
      let foundGame = this.model.betting_detail.filter(
        b => b.game_lot_name == game.game_lot_name
      )
      if (foundGame.length > 0) {
        this.model.betting_detail.splice(
          this.model.betting_detail.indexOf(game),
          1
        )
      } else {
        this.model.betting_detail.push(game)
      }
    }
  },
  watch: {
    gameSet: {
      handler() {
        this.createDetail()
      },
      deep: true
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    },
    rebuild: function(value) {
      if (value) {
        this.createDetail()
        this.isChecked = true
        this.$nextTick(() => {
          this.isChecked = false
        })
        this.$emit('clear')
      }
    }
  }
}
</script>
